import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-collapsibles-page-ui',
    templateUrl: './bb-collapsibles-page-ui.component.html',
    styles: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class BbCollapsiblesPageUiComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
